document.addEventListener('DOMContentLoaded', function() {
  setTimeout(initStickyCartButton, 1000);
  
  function getSwatchBackground(swatchEl) {
    const colorEl = swatchEl.querySelector('.block-swatch__color');
    const target = colorEl || swatchEl;
    const style = target.getAttribute('style');
    if (style) return style;
    const img = swatchEl.querySelector('img');
    if (img?.src) return 'background: url(' + img.src + ') center/cover';
    return 'background: #ccc';
  }
  
  function formatPrice(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100).replace('€', '').trim() + ' €';
  }
  
  function initStickyCartButton() {
    const mainAddToCartBtn = document.querySelector('.product-info__buy-buttons .button');
    const productForm = document.querySelector('form[action="/cart/add"]');
    
    if (!mainAddToCartBtn || !productForm) return;
    
    const isProductPage = document.querySelector('.product-gallery') !== null;
    if (!isProductPage) return;
    
    const mainPriceElement = document.querySelector('price-list sale-price');
    const variantIdInput = productForm.querySelector('input[name="id"]');
    const variantId = variantIdInput?.value;
    
    let productHandle = null;
    const swatchWithHref = document.querySelector('.color-swatch.is-selected[href], .block-swatch.is-selected[href]') || document.querySelector('.color-swatch[href], .block-swatch[href]');
    if (swatchWithHref?.getAttribute('href')) {
      const match = swatchWithHref.getAttribute('href').match(/\/products\/([^/?]+)/);
      if (match) productHandle = match[1];
    }
    if (!productHandle && window.location.pathname.includes('/products/')) {
      productHandle = window.location.pathname.split('/products/')[1]?.split('/')[0]?.split('?')[0];
    }
    
    const originalColorSwatches = document.querySelectorAll('.product-info .color-swatch, .product-info .block-swatch, .product-info .thumbnail-swatch');
    
    let productTitle = document.querySelector('.product-info__title')?.textContent?.trim() || '';
    let productImage = (() => {
      const img = document.querySelector('.product-gallery__media.is-selected img, .product-gallery__media:not([hidden]) img, .product-gallery img');
      return img?.getAttribute('src') || '';
    })();
    let productPrice = mainPriceElement?.textContent?.trim().match(/[\d,.]+\s*€/)?.[0]?.trim() || '';
    const selectedVariantValue = document.querySelector('.product[data-product-color]')?.getAttribute('data-product-color') || '';
    
    const stickyButtonContainer = document.createElement('div');
    stickyButtonContainer.className = 'sticky-cart-button';
    stickyButtonContainer.id = 'sticky-cart-button-container';
    
    const innerContainer = document.createElement('div');
    innerContainer.className = 'sticky-cart-button-container';
    stickyButtonContainer.appendChild(innerContainer);
    
    const leftSide = document.createElement('div');
    leftSide.className = 'sticky-cart-left';
    
    const productImageEl = document.createElement('img');
    productImageEl.className = 'sticky-cart-product-image';
    productImageEl.src = productImage || 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80"%3E%3Crect fill="%23eee" width="80" height="80"/%3E%3C/svg%3E';
    productImageEl.alt = productTitle;
    leftSide.appendChild(productImageEl);
    
    const productInfoEl = document.createElement('div');
    productInfoEl.className = 'sticky-cart-product-info';
    
    const productTitleEl = document.createElement('p');
    productTitleEl.className = 'sticky-cart-product-title';
    productTitleEl.textContent = productTitle;
    productInfoEl.appendChild(productTitleEl);
    
    // Add variant picker
    if (originalColorSwatches.length > 0) {
      const variantSectionEl = document.createElement('div');
      variantSectionEl.className = 'sticky-cart-variant-section';
      
      const variantLabelEl = document.createElement('span');
      variantLabelEl.className = 'sticky-cart-variant-label';
      variantLabelEl.textContent = "Farbe:";
      variantSectionEl.appendChild(variantLabelEl);
      
      const variantValueEl = document.createElement('span');
      variantValueEl.className = 'sticky-cart-variant-value';
      variantValueEl.textContent = selectedVariantValue || '';
      variantSectionEl.appendChild(variantValueEl);
      
      const variantPickerEl = document.createElement('div');
      variantPickerEl.className = 'sticky-cart-variant-picker';
      
      originalColorSwatches.forEach((originalSwatch) => {
        const colorSwatch = document.createElement('div');
        colorSwatch.className = 'sticky-cart-color-swatch';
        colorSwatch.setAttribute('style', getSwatchBackground(originalSwatch));
        
        if (originalSwatch.classList.contains('is-selected')) {
          colorSwatch.classList.add('is-selected');
        }
        
        colorSwatch.addEventListener('click', function() {
          originalSwatch.click();
        });
        
        variantPickerEl.appendChild(colorSwatch);
      });
      
      variantSectionEl.appendChild(variantPickerEl);
      productInfoEl.appendChild(variantSectionEl);
    }
    
    leftSide.appendChild(productInfoEl);
    innerContainer.appendChild(leftSide);
    
    const rightSide = document.createElement('div');
    rightSide.className = 'sticky-cart-price-button';
    
    const productPriceEl = document.createElement('div');
    productPriceEl.className = 'sticky-cart-product-price';
    productPriceEl.innerHTML = productPrice;
    if (mainPriceElement?.classList.contains('text-on-sale')) {
      productPriceEl.classList.add('text-on-sale');
    }
    rightSide.appendChild(productPriceEl);
    
    const stickyButton = document.createElement('button');
    stickyButton.type = 'button';
    stickyButton.id = 'sticky-cart-button';
    stickyButton.textContent = mainAddToCartBtn.textContent.trim();
    stickyButton.setAttribute('aria-label', 'Add to cart');
    
    if (mainAddToCartBtn.classList.contains('sold-out') || mainAddToCartBtn.disabled) {
      stickyButton.disabled = true;
      stickyButton.classList.add('disabled');
    }
    
    stickyButton.addEventListener('click', function() {
      if (!stickyButton.disabled) {
        // Show loading state
        stickyButton.classList.add('is-loading');
        
        // Get variant ID from main form
        const mainForm = document.querySelector('form[action="/cart/add"]');
        const variantId = mainForm?.querySelector('input[name="id"]')?.value;
        
        if (!variantId) {
          console.error('No variant ID found');
          stickyButton.classList.remove('is-loading');
          return;
        }

        // Add to cart using AJAX
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1
            }]
          })
        })
        .then(response => response.json())
        .then(data => {
          // Remove loading state
          stickyButton.classList.remove('is-loading');

          // Trigger cart drawer open
          if (window.theme && typeof window.theme.openCartDrawer === 'function') {
            window.theme.openCartDrawer();
          } else {
            // Fallback: dispatch event that Shopify's theme might listen to
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:open', {
                bubbles: true
              })
            );
            
            // Additional fallback: try to find and click the cart drawer trigger
            const cartTrigger = document.querySelector('[data-action="open-drawer"][aria-controls="cart-drawer"]');
            if (cartTrigger) {
              cartTrigger.click();
            }
          }

          // Update cart count if exists
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              const cartCount = document.querySelector('.header__cart-count');
              if (cartCount) {
                cartCount.textContent = cart.item_count;
              }
            })
            .catch(error => console.error('Error fetching cart:', error));
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          stickyButton.classList.remove('is-loading');
          
          // Fallback to main button click if AJAX fails
          mainAddToCartBtn.click();
        });
      }
    });
    
    rightSide.appendChild(stickyButton);
    innerContainer.appendChild(rightSide);
    
    document.body.appendChild(stickyButtonContainer);

    // Fetch product data to update image, price, variant value dynamically
    if (productHandle) {
      fetch('/products/' + productHandle + '.js')
        .then(response => response.json())
        .then(product => {
          const variant = product.variants?.find(v => String(v.id) === String(variantId)) || product.variants?.[0];
          if (!variant) return;
          
          const formattedPrice = formatPrice(variant.price);
          if (productPriceEl) {
            productPriceEl.textContent = formattedPrice;
            productPriceEl.classList.toggle('text-on-sale', variant.compare_at_price > variant.price);
          }
          
          const variantImage = variant.featured_media?.preview_image?.src || variant.featured_media?.src || 
            (product.featured_image?.src || product.featured_image) || product.media?.[0]?.src;
          if (variantImage && productImageEl) {
            productImageEl.style.opacity = '0';
            productImageEl.src = variantImage;
            productImageEl.onload = () => { productImageEl.style.opacity = '1'; };
          }
          
          if (productTitleEl && product.title) productTitleEl.textContent = product.title;
          
          const variantValueEl = document.querySelector('.sticky-cart-variant-value');
          const colorValue = variant.option1 && variant.option1 !== 'Default Title' ? variant.option1 : document.querySelector('.product[data-product-color]')?.getAttribute('data-product-color');
          if (variantValueEl && colorValue) variantValueEl.textContent = colorValue;
        })
        .catch(error => console.error('Error fetching product data:', error));
    }

    // Listen for product updates
    document.addEventListener('product:update', function(event) {
      if (!event.detail) return;
      
      const { product, variant, selectedColor, hasVisibleComparePrice } = event.detail;

      // Update variant selection
      const variantValueEl = document.querySelector('.sticky-cart-variant-value');
      if (variantValueEl && selectedColor && selectedColor !== 'Default Title') {
        variantValueEl.textContent = selectedColor;
      }

      // Update swatch selection
      const stickySwatches = document.querySelectorAll('.sticky-cart-color-swatch');
      const originalSwatches = document.querySelectorAll('.color-swatch[href], .block-swatch[href]');
      stickySwatches.forEach((swatch, index) => {
        swatch.classList.remove('is-selected');
        if (originalSwatches[index]?.classList.contains('is-selected')) {
          swatch.classList.add('is-selected');
        }
      });

      // Update price with proper formatting
      const mainPrice = document.querySelector('price-list sale-price');
      if (mainPrice && productPriceEl) {
        const priceText = mainPrice.textContent.trim();
        if (priceText) {
          // Extract only the price part (numbers, commas, dots, and €)
          const priceMatch = priceText.match(/[\d,.]+\s*€/);
          if (priceMatch) {
            productPriceEl.textContent = priceMatch[0].trim();
          }
        }
        productPriceEl.className = 'sticky-cart-product-price';
        
        // Update price color based on compare price visibility
        const compareAtPrice = document.querySelector('price-list compare-at-price');
        const hasVisibleComparePrice = compareAtPrice && !compareAtPrice.hasAttribute('hidden');
        
        if (hasVisibleComparePrice) {
          productPriceEl.classList.add('text-on-sale');
        } else {
          productPriceEl.classList.remove('text-on-sale');
        }
      }

      // Update button state
      if (mainAddToCartBtn) {
        stickyButton.disabled = mainAddToCartBtn.disabled;
        stickyButton.classList.toggle('disabled', mainAddToCartBtn.disabled);
      }
    });

    // Listen for variant change (standard variant picker)
    productForm.addEventListener('variant:change', function(event) {
      const variant = event.detail?.variant;
      if (!variant || !productImageEl) return;
      const variantImage = variant.featured_media?.preview_image?.src || variant.featured_media?.src;
      if (variantImage) {
        productImageEl.style.opacity = '0';
        productImageEl.src = variantImage;
        productImageEl.onload = () => { productImageEl.style.opacity = '1'; };
      }
      const variantValueEl = document.querySelector('.sticky-cart-variant-value');
      const colorValue = variant.option1 && variant.option1 !== 'Default Title' ? variant.option1 : document.querySelector('.product[data-product-color]')?.getAttribute('data-product-color');
      if (variantValueEl && colorValue) variantValueEl.textContent = colorValue;
    });

    // Listen for gallery updates (product_variations fires this when initial load completes)
    document.addEventListener('gallery:updated', function(event) {
      if (!event.detail?.productImage || !productImageEl) return;
      productImageEl.style.opacity = '0';
      productImageEl.src = event.detail.productImage;
      if (productImageEl.complete) {
        requestAnimationFrame(() => productImageEl.style.opacity = '1');
      } else {
        productImageEl.onload = () => requestAnimationFrame(() => productImageEl.style.opacity = '1');
      }
    });

    // Add transition styles for smooth image updates
    if (productImageEl) {
      productImageEl.style.transition = 'opacity 0.2s ease-in-out';
    }

    // Update visibility on scroll
    function checkMainButtonVisibility() {
      const buyButtonsContainer = document.querySelector('.product-info__buy-buttons');
      if (!buyButtonsContainer) return;
      
      const rect = buyButtonsContainer.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
      const elementHeight = rect.bottom - rect.top;
      
      if (visibleHeight <= elementHeight * 0.3) {
        stickyButtonContainer.classList.add('visible');
      } else {
        stickyButtonContainer.classList.remove('visible');
      }
    }

    window.addEventListener('scroll', throttle(checkMainButtonVisibility, 100));
    window.addEventListener('resize', throttle(checkMainButtonVisibility, 100));
    checkMainButtonVisibility();
  }
  
  function throttle(callback, limit) {
    let waiting = false;
    return function() {
      if (!waiting) {
        callback.apply(this, arguments);
        waiting = true;
        setTimeout(function() {
          waiting = false;
        }, limit);
      }
    };
  }
}); 